var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.customerCode == 305)?_c('Gallery110UserLoanPrintHtml',{attrs:{"userLoanId":_vm.userLoanId,"area":_vm.area},on:{"ready":function($event){return _vm.$emit('ready')}}}):_c('DefaultUserLoanPrintHtml',{attrs:{"userLoanId":_vm.userLoanId,"area":_vm.area},on:{"ready":function($event){return _vm.$emit('ready')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }